import "core-js/stable";
import "regenerator-runtime/runtime";

import { Power2, gsap } from "gsap";

import { Scroll } from './_app/cuchillo/scroll/Scroll';
import { VSticky } from './_app/cuchillo/scroll/insiders/VSticky';
import { VScaleZero } from './_app/cuchillo/scroll/insiders/VScaleZero';
import { VScale } from './_app/cuchillo/scroll/insiders/VScale';
import { VInsider } from './_app/cuchillo/scroll/insiders/VInsider';
import { VDisplace } from './_app/cuchillo/scroll/insiders/VDisplace';
import { VInsiderMask } from './_app/cuchillo/scroll/insiders/VInsiderMask';
// import { VSliderImage } from './scroll/VSliderImage';

// import { ScrollItem__SliderScrollHorizontal } from './scroll/ScrollItem__SliderScrollHorizontal';
// import { ScrollItem__Instagram } from './scroll/ScrollItem__Instagram';
// import { ScrollItem__ProjectList } from './scroll/ScrollItem__ProjectList';
// import { ScrollItem__BillboardProject } from './scroll/ScrollItem__BillboardProject';
// import { ScrollItem__Form } from './scroll/ScrollItem__Form';
// import { ScrollItem__Stock } from './scroll/ScrollItem__Stock';
// import { ScrollItem__Default3D } from './scroll/ScrollItem__Default3D';
// import { ScrollItem__BillboardBurger } from './scroll/ScrollItem__BillboardBurger';
import { ScrollItem__SliderFullScreen } from './scroll/ScrollItem__SliderFullScreen';
// import { VSliderImage } from './scroll/VSliderImage';
// import { ScrollItem__3D_Gallery } from './scroll/ScrollItem__3D_Gallery';
// import { ScrollItem__SliderDefault } from './scroll/ScrollItem__SliderDefault';
// import { ScrollItem__ProductsList } from './scroll/ScrollItem__ProductsList';

import { Accessibility } from './_app/cuchillo/core/Accessibility';
import { Basics, isDebug, isTouch } from './_app/cuchillo/core/Basics';
import EventDispatcher from './_app/cuchillo/core/EventDispatcher';
import { Interaction, MrInteraction } from './_app/cuchillo/core/Interaction';
import { GetBy } from "./_app/cuchillo/core/Element";
import { Metrics } from './_app/cuchillo/core/Metrics';
import { Statics } from './_app/cuchillo/utils/Statics';
import Keyboard from './_app/cuchillo/core/Keyboard';

import LoaderController from './_app/cuchillo/loaders/LoaderController';
import PagesLoader from './_app/cuchillo/loaders/PagesLoader';
import MediaLoader from './_app/cuchillo/loaders/MediaLoader';

import { ControllerPage } from './_app/cuchillo/pages/ControllerPage';
import Page from './_app/cuchillo/pages/Page';
import Default from './pages/Default';
// import Legal from './pages/Legal';
import NoScroll from './pages/NoScroll';
import Project from './pages/Project';
import NotFound from './pages/NotFound';

import BG from './_app/cuchillo/layout/Background';
import InterfaceCanvas from './_app/cuchillo/layout/InterfaceCanvas';
// import Header from './layout/Header';
import Loading from './layout/Loading';
import Wrap from './layout/Wrap';

// import { ControllerWindow } from './_app/cuchillo/windows/ControllerWindow';
// import Win from './_app/cuchillo/windows/Window';
import Preloader from "./layout/Preloader";
// import Sidemenu from "./layout/Sidemenu";
import Language from "./_app/cuchillo/utils/Language";

// import CMP from "./windows/Cmp";
import Scene from './3D/Scene';
import WebGLSketch from './_app/cuchillo/3D/WebGLSketch';
// import GeometryController from './_app/cuchillo/3D/GeometryController';
// import TexturesController from './_app/cuchillo/3D/TexturesController';

export default class Main {
  static stats;

  static init() {
    gsap.ticker.fps(60);

    Basics.id = "GraciasGrecia_"; // ID para cookies   
    Language.init();
    // Header.init();
    // Sidemenu.init();
    WebGLSketch.init();
    Scene.init();

    Metrics.init(() => Main.resize()); // Tamaños y resize
    Keyboard.enable(); // ESC para cerrar ventana
    Accessibility.init(); // Utils accesibilidad
    Statics.init(); // Si estamos en debug pinta un FPS counter
    Interaction.init({ ajax: true }) // Posiciones del cursor (Movimiento, click...), Acciones links, drag...
    // ControllerWindow.init(); // Control ventanas

    BG.init(CMS_COLORS); // Control de paletas y color de fondo de pantallas. Automatico si añadimos un data-palette='loquesea' en el div con data-page
    InterfaceCanvas.init(); // Canvas de interface, se usa con Cursor
    // CMP.init(); // Checkea y saca el aviso de cookies

    LoaderController.add(new PagesLoader()); // Carga/Precarga de paginas HTML
    LoaderController.add(new MediaLoader()); // Carga/Precarga de imgs
    LoaderController.update = progress => Preloader.update(progress);
    LoaderController.onComplete = () => Main.setup();

    this.setWorker();

    // LOOP
    if (isDebug) {
      gsap.ticker.add(() => { Main.loopDebug(); });
    } else {
      gsap.ticker.add(() => { Main.loop(); });
    }

    Preloader.init();
    LoaderController.init();
  }

  static setup() {
    this.setupEvents();
    // INIT PAGE
    ControllerPage.init(Wrap.mainholder);
  }

  static setupEvents() {
    EventDispatcher.addEventListener(Page.ON_SHOW, () => {
      Loading.stop();
    });
    // EventDispatcher.addEventListener(Page.ON_HIDE, () => {
    //Cursor.hide();
    // Sidemenu.hide();
    // });
    EventDispatcher.addEventListener(Page.ON_HIDE_END, () => {
      Loading.start();
    });

    // EventDispatcher.addEventListener(Win.ON_HIDE, () => { Scroll.setEnabled(true); });
    // EventDispatcher.addEventListener(Win.ON_SHOW, () => { Scroll.setEnabled(false); });
    // EventDispatcher.addEventListener(Sidemenu.ON_HIDE, () => { Scroll.setEnabled(true); });
    // EventDispatcher.addEventListener(Sidemenu.ON_SHOW, () => {
    //   Scroll.setEnabled(false);
    //   ControllerWindow.hideAll();
    // });
  }

  static resize() {
    InterfaceCanvas.resize();
    BG.resize();
    ControllerPage.resize();
    WebGLSketch.resize();
    Scene.resize();

    // if (isTouch) GetBy.id('Main').style.height = `${Metrics.HEIGHT}px`;
  }

  static loop() {
    if (Scroll.isScrolling) Scroll.loop();

    ControllerPage.loop();
    BG.loop();
    InterfaceCanvas.loop();
    Scene.loop();
    WebGLSketch.loop();
  }

  static loopDebug() {
    Statics.begin();
    this.loop();
    Statics.end();
  }

  static setWorker() {
    if ('serviceWorker' in navigator && !isDebug) {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(function () { });
    }
  }
}

if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
  Main.init();
} else {
  document.addEventListener('DOMContentLoaded', Main.init);
}
